'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.permissionNameList = exports.isDemoBoard = exports.calculatePermissionValue = exports.isOwner = exports.canEditPermissions = exports.canSave = exports.canWrite = exports.canRead = undefined;

var _permissionConstants = require('./permissionConstants');

var canRead = exports.canRead = function canRead(permission) {
    return _permissionConstants.ACCESS_BITS.READ === (permission & _permissionConstants.ACCESS_BITS.READ);
};
var canWrite = exports.canWrite = function canWrite(permission) {
    return _permissionConstants.ACCESS_BITS.WRITE === (permission & _permissionConstants.ACCESS_BITS.WRITE);
};
var canSave = exports.canSave = function canSave(permission) {
    return _permissionConstants.ACCESS_BITS.SAVE === (permission & _permissionConstants.ACCESS_BITS.SAVE);
};
var canEditPermissions = exports.canEditPermissions = function canEditPermissions(permission) {
    return _permissionConstants.ACCESS_BITS.PERMISSIONS === (permission & _permissionConstants.ACCESS_BITS.PERMISSIONS);
};
var isOwner = exports.isOwner = function isOwner(permission) {
    return _permissionConstants.ACCESS_BITS.OWNER === (permission & _permissionConstants.ACCESS_BITS.OWNER);
};

var calculatePermissionValue = exports.calculatePermissionValue = function calculatePermissionValue(_ref) {
    var _ref$read = _ref.read,
        read = _ref$read === undefined ? true : _ref$read,
        _ref$write = _ref.write,
        write = _ref$write === undefined ? true : _ref$write,
        _ref$save = _ref.save,
        save = _ref$save === undefined ? true : _ref$save,
        _ref$permissions = _ref.permissions,
        permissions = _ref$permissions === undefined ? true : _ref$permissions,
        _ref$owner = _ref.owner,
        owner = _ref$owner === undefined ? false : _ref$owner;
    return (read ? _permissionConstants.ACCESS_BITS.READ : 0) + (write ? _permissionConstants.ACCESS_BITS.WRITE : 0) + (save ? _permissionConstants.ACCESS_BITS.SAVE : 0) + (permissions ? _permissionConstants.ACCESS_BITS.PERMISSIONS : 0) + (owner ? _permissionConstants.ACCESS_BITS.OWNER : 0);
};

// demo board can be read & written to, but not saved
var isDemoBoard = exports.isDemoBoard = function isDemoBoard(permission) {
    return canRead(permission) && canWrite(permission) && !canSave(permission);
};

var permissionNameList = exports.permissionNameList = function permissionNameList(permission) {
    return Object.keys(_permissionConstants.ACCESS_BITS).reduce(function (acc, key) {
        var permissionValue = _permissionConstants.ACCESS_BITS[key];
        if (permissionValue === permission & permissionValue) acc.push(key);
        return acc;
    }, []);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/permissions/permissionUtil.js
// module id = 89
// module chunks = 0